var $ = require('jquery');
require('../web/jquery.unveil');

"use strict";

var PLUGIN_NAME = "betonSlider";

var DEFAULTS = {
    minScreenWidth: 768,
    motiveOuterWidth: 643,
    data: [],
    slideContentFormatter: function(data) {
        var resultCnt = '';
        var result = '';
        var lastResult = '';
        var width = 0;
        var unveilPrefix;
        for (var i = 0; i < data.length; i++) {
            if (data[i].inspirationGallery && data[i].inspirationGallery == true) {
              window.projectConfig.favoritesRelationArr.push([data[i].id, data[i].rowId]);
              result += '<li>';
              result += '<div class="inspirationGalleryItemCnt">';
              var motiveTitle = '';
              if (data[i].title && data[i].title != '') {
                motiveTitle = data[i].title;
              }
              result += '<span class="inspirationFavoritesControlButton glyphicon glyphicon-favorites" data-motive-id="' + data[i].id + '" data-motive-title="' + motiveTitle + '">';
              result +=  '<em>';
              result +=  '<strong>';
              result +=  locale['inspirationAddToFavorites'];
              result +=  '</strong>';
              result +=  '</em>';
              result += '</span>';
              if (data[i].link) {
                var captionText = '';
                var headingText = '';
                var actualDay = new Date().getDate();
                var actualMonth = new Date().getMonth() + 1;
                var actualYear = new Date().getFullYear();
                var mailSubject = locale['yourInspirationFrom'] + actualDay + '. ' + actualMonth + '. ' + actualYear;
                var socialShareStr = '<li><a target="_blank" href="http://www.facebook.com/sharer/sharer.php?u=' + window.location.protocol + '//' + window.location.hostname + data[i].motive + '&t=' + data[i].title + '" class="glyphicon glyphicon-favorites-facebook" data-social-network="fb">' + locale['shareOnFacebook'] + '</a></li><li><a target="_blank" href="http://pinterest.com/pin/create/button/?url=' + window.location.protocol + '//' + window.location.hostname + data[i].motive + '&description=' + data[i].title + '" class="glyphicon glyphicon-favorites-pinterest socialShareInHs" data-social-network="pinterest">' + locale['shareOnPinterest'] + '</a></li><li><a href="mailto:?to=&body=' + locale['mailBodyText'] + window.location.protocol + '//' + window.location.hostname + data[i].motive + '&subject=' + mailSubject + '" class="glyphicon glyphicon-favorites-mail shareByMail">' + locale['shareByMail'] + '</a></li>';
                if (data[i].descriptionLine2 && data[i].descriptionLine2 != '') {
                  captionText += '<div class="inspirationGalleryHsCnt">';
                  captionText += '<h4>';
                  captionText += locale['productPages'];
                  captionText += '</h4>';
                  captionText += '<ul class="inspirationGalleryHsDescription clearfix">' + data[i].descriptionLine2 + '</ul>';
                  captionText += '</div>';
                  captionText = captionText.replace(/(?:\r\n|\r|\n)/g, '');
                  captionText = captionText.replace(/"/g, "&quot;");
                  headingText += '<div class="inspirationGalleryHsShareControls">';
                  headingText += '<ul class="clearfix">';
                  headingText += '<li>';
                  headingText += '<span class="inspirationFavoritesControlButtonInCaption inspirationFavoritesControlButton inspirationAddToFavorites glyphicon glyphicon-favorites" data-motive-id="' + data[i].id + '"></span>';
                  headingText += '</li>';
                  headingText += socialShareStr;
                  headingText += '</ul>';
                  headingText += '</div>';
                  headingText = headingText.replace(/(?:\r\n|\r|\n)/g, '');
                  headingText = headingText.replace(/"/g, "&quot;");
                  result += '<a class="inspirationGalleryImage" href="' + data[i].motive + '" onclick="return hs.expand(this, {slideshowGroup: &quot;' + data[i].galleryId + '&quot;, captionText: &apos;' + captionText + '&apos;, headingText: &apos;' + headingText + '&apos;})">';
                  hs.addSlideshow({ slideshowGroup: data[i].galleryId});
                } else {
                  result += '<a class="inspirationGalleryImage" href="' + data[i].motive + '" onclick="return hs.expand(this, {slideshowGroup: &quot;' + data[i].galleryId + '&quot;})">';
                  hs.addSlideshow({ slideshowGroup: data[i].galleryId});
                }
              } else {
                result += '<div>';
              }

              if (data[i].motiveThumbnail) {
                if ( i < 5 ) {
                  unveilPrefix = '';
                } else {
                  unveilPrefix = 'src="/img/u/gallery-placeholder.jpg" data-';
                }
                result += '<div class="slider-image-cnt">';
                result += '<img draggagle="false" ' + unveilPrefix + 'src="' + data[i].motiveThumbnail + '" class="img-responsive" alt="' + data[i].title + '">';
                result += '</div>';
                result += '</a>';
              }
              if ((data[i].descriptionLine1 && data[i].descriptionLine1 != '') || (data[i].descriptionLine2 && data[i].descriptionLine2 != '')){
                result += '<div class="description">';
                if ((data[i].descriptionLine1 && data[i].descriptionLine1 != '') ||(data[i].title && data[i].title != '')) {
                  result += '<div class="inspirationItemContent">';
                }
                if (data[i].title && data[i].title != '') {
                  result += '<h4>' + data[i].title + '</h4>';
                }
                if (data[i].descriptionLine1 && data[i].descriptionLine1 != '') {
                  result += data[i].descriptionLine1;
                }
                if ((data[i].descriptionLine1 && data[i].descriptionLine1 != '') ||(data[i].title && data[i].title != '')) {
                  result += '</div>';
                }
                result += '<div class="clearfix inspirationControlButtons">';
                result += '<span class="btn btn-gray-17 triggerGallery">';
                result +=  locale['showGallery'];
                result += '</span>';
                result += '</div>';
                if (data[i].descriptionLine2 && data[i].descriptionLine2 != '') {
                result += '<ul class="clearfix">';
                  result += data[i].descriptionLine2;
                result += '</ul>';
                }
                result += '</div>';
              }
              result += '</div>';
              result += '</li>';

              if ( $(window).width() < 1083 ) {
                width += ((this.motiveOuterWidth - 10) / 2) + 10;
              } else {
                width += this.motiveOuterWidth;
              }
            } else {
                result += '<li>';
                if (data[i].link) {
                  if (((data[i].link).toLowerCase().indexOf('.jpg') > -1) || ((data[i].link).toLowerCase().indexOf('.png') > -1) || ((data[i].link).toLowerCase().indexOf('.bmp') > -1) || ((data[i].link).toLowerCase().indexOf('.jpeg') > -1) || ((data[i].link).toLowerCase().indexOf('.gif') > -1)) {
                    var captionText = '';
                    var captionTextParsed;
                    if (data[i].title && data[i].title != '' && data[i].descriptionLine1 && data[i].descriptionLine1 != '' && data[i].descriptionLine2 && data[i].descriptionLine2 != '') {
                      captionTextParsed = data[i].title;
                      captionTextParsed = captionTextParsed.replace(' - ' + data[i].descriptionLine1, '');
                      captionTextParsed = captionTextParsed.replace(' - ' + data[i].descriptionLine2, '');
                      captionText += '<strong>' + captionTextParsed + '</strong>' + '; ' + data[i].descriptionLine1 + '; ' + data[i].descriptionLine2;
                      result += '<a href="' + data[i].link + '" onclick="return hs.expand(this, {slideshowGroup: &quot;' + data[i].galleryId + '&quot;, captionText: &quot;' + captionText + '&quot;})">';
                      hs.addSlideshow({ slideshowGroup: data[i].galleryId});
                    } else if (data[i].title && data[i].title != '' && data[i].descriptionLine1 && data[i].descriptionLine1 != '') {
                      captionTextParsed = data[i].title;
                      captionTextParsed = captionTextParsed.replace(' - ' + data[i].descriptionLine1, '');
                      captionText += '<strong>' + captionTextParsed + '</strong>' + '; ' + data[i].descriptionLine1;
                      result += '<a href="' + data[i].link + '" onclick="return hs.expand(this, {slideshowGroup: &quot;' + data[i].galleryId + '&quot;, captionText: &quot;' + captionText + '&quot;})">';
                      hs.addSlideshow({ slideshowGroup: data[i].galleryId});
                    } else if (data[i].title && data[i].title != '') {
                      captionText += '<strong>' + data[i].title + '</strong>';
                      result += '<a href="' + data[i].link + '" onclick="return hs.expand(this, {slideshowGroup: &quot;' + data[i].galleryId + '&quot;, captionText: &quot;' + captionText + '&quot;})">';
                      hs.addSlideshow({ slideshowGroup: data[i].galleryId});
                    } else {
                      result += '<a href="' + data[i].link + '" onclick="return hs.expand(this, {slideshowGroup: &quot;' + data[i].galleryId + '&quot;})">';
                      hs.addSlideshow({ slideshowGroup: data[i].galleryId});
                    }
                  } else {
                    result += '<a href="' + data[i].link + '">';
                  }
                } else {
                    result += '<div>';
                }

                if (data[i].motive) {
                  if ( i < 5 ) {
                    unveilPrefix = '';
                  } else {
                    unveilPrefix = 'src="/img/u/gallery-placeholder.jpg" data-';
                  }
                    result += '<div class="slider-image-cnt">';
                    result += '<img ' + unveilPrefix + 'src="' + data[i].motive + '" class="img-responsive" alt="' + data[i].title + '">';
                    result += '</div>';
                }

                if ((data[i].title && data[i].title != '') || (data[i].descriptionLine1 && data[i].descriptionLine1 != '') || (data[i].descriptionLine2 && data[i].descriptionLine2 != '') ){
                    result += '<div class="description">';
                    if (data[i].title && data[i].title != '') {
                      var newTitle = data[i].title;
                      if (data[i].descriptionLine1 && data[i].descriptionLine1 != '') {
                        newTitle = newTitle.replace(' - ' + data[i].descriptionLine1, '');
                      }
                      if (data[i].descriptionLine2 && data[i].descriptionLine2 != '') {
                        newTitle = newTitle.replace(' - ' + data[i].descriptionLine2, '');
                      }
                        result += '<h3>' + newTitle + '</h3>';
                    }
                    result += '<ul>';
                    if (data[i].descriptionLine1 && data[i].descriptionLine1 != '') {
                        result += '<li>' + data[i].descriptionLine1 + '</li>';
                    }
                    if (data[i].descriptionLine2 && data[i].descriptionLine2 != '') {
                        result += '<li>' + data[i].descriptionLine2 + '</li>';
                    }
                    result += '</ul>';
                    result += '</div>';
                }
                if (data[i].link) {
                    result += '</a>';
                } else {
                    result += '</div>';
                }
                result += '</li>';
                //width += this.motiveOuterWidth;
                if ( $(window).width() < 1083 ) {
                    width += ((this.motiveOuterWidth - 3) / 2) + 3;
                } else {
                    width += this.motiveOuterWidth;
                }
            }
        }
        //resultCnt += '<ul class="clearfix" style="width: ' + width + 'px; margin-left: -' + this.motiveOuterWidth + 'px">';
        resultCnt += '<ul class="clearfix" style="width: ' + width + 'px; margin-left: 0">';
        //resultCnt += lastResult;
        resultCnt += result;
        resultCnt += '</ul>';
        return resultCnt;
    },
    controlArrows: true,
    slideTime: 8000,
    slideDuration: 800,
    effect: 'slide'
};

// The actual plugin constructor
function BetonSlider(element, options) {
    this.element = element;
    this.parentElement = $(element).parents('.sliderCnt');
    this.animating = false;

    this.options = $.extend(true, {}, DEFAULTS, options);
    this._wWidth = window.innerWidth;

    this._defaults = DEFAULTS;
    this._name = PLUGIN_NAME;

    this._changeTimer = null;
    this.initialise();
    this.listenForResize();
    this.listenForLoad();
}

/**
 * init
 */
BetonSlider.prototype.initialise = function() {

    if (this._wWidth < this.options.minScreenWidth) {
        //$(this.element).empty().hide();
        //return false;
    }
    $(this.element).show();
    this.actualSlide = 0;

    if (this.options.data.length > 0) {
        this.renderSlides();
    }

    if (this.options.data.length > 1) {
        this.renderControls();
        //this.startRotation();
    } else {
        $(this.parentElement).addClass('hideSliderRightShadow');
    }

    $(document).trigger('betonSliderLoaded');
};

/**
 * read data and build slides list
 */
BetonSlider.prototype.renderSlides = function() {
    var htmlResult = this.options.slideContentFormatter(this.options.data);
    $(this.element).html(htmlResult);
};

/**
 * render controls
 */
BetonSlider.prototype.renderControls = function() {
    this.controlArrows = (this.options.controlArrows) ? this.renderControlArrows() : null;
    //this.controlPoints = (this.options.controlPoints) ? this.renderControlPoints() : null;

    if (this.controlArrows) {
        $(this.parentElement).append(this.controlArrows);
        this.bindControlArrows();
    }
};

/**
 * renders control arrows
 */
BetonSlider.prototype.renderControlArrows = function() {
    var str = '';
    str += '<span class="glyphicon glyphicon-arrow-left slider-arrow prev"></span>';
    str += '<span class="glyphicon glyphicon-arrow-right slider-arrow next"></span>';
    return str;
};

/**
 * bind action to control arrows
 */
BetonSlider.prototype.bindControlArrows = function() {
    var self = this;
    $('span.slider-arrow', $(this.parentElement)).bind('click', function() {
        if ( self.animating == true ) {
            return false;
        } else {
            clearTimeout(this._changeTimer);
            if ($(this).hasClass('prev')) {
                self.rotate(self.actualSlide, 'prev');
            }

            if ($(this).hasClass('next')) {
                self.rotate(self.actualSlide, 'next');
            }
        }
    });

    $('.gallerySlider > ul, .slider > ul, .slider > ul li img', $(this.parentElement)).swipe( {
        //Generic swipe handler for all directions
        swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
            if ( direction == 'left' ) {
                if (!($(self.parentElement).hasClass('hideSliderRightShadow'))) {
                    self.rotate(self.actualSlide, 'next');
                }
            } else if ( direction == 'right' ) {
                if ($(self.parentElement).hasClass('showSliderShadows')) {
                    self.rotate(self.actualSlide, 'prev');
                }
            }
        }
    });
};

/**
 *
 */
BetonSlider.prototype.rotate = function(from, direction) {
    var newSlide = this.actualSlide;
    clearTimeout(this._changeTimer);
    if (direction == "prev") {
        newSlide--;
        newSlide = (newSlide < 0) ? this.options.data.length - 1 : newSlide;
    }

    if (direction == "next") {
        newSlide++;
        newSlide = (newSlide >= this.options.data.length) ? 0 : newSlide;
        $('img', this.element).unveil();
    }

    this.changeSlide(this.actualSlide, newSlide, direction);
};

/**
 *
 * @param from
 * @param to
 */
BetonSlider.prototype.changeSlide = function(from, to, direction) {
    var self = this;

    if (from == to) {
        return false;
    }

    if ( self.options.effect == 'slide' ) {

        var el = this.element;
        var parentEl = this.parentElement;
        var windowWidth = $(window).width();
        var sliderLeftOffset = $(this.element).offset().left;
        var width = $('>ul', this.element).width();
        //var sliderEndPosition = width - windowWidth + sliderLeftOffset;

        var actualMove, actualMargin, motiveOuterWidth;
        if ( $(window).width() < 1083 ) {
            motiveOuterWidth = ((this.options.motiveOuterWidth - 3) / 2) + 3;
        } else {
            motiveOuterWidth = this.options.motiveOuterWidth;
        }
        //var sliderEndPosition = width - windowWidth + sliderLeftOffset - motiveOuterWidth;
        var sliderEndPosition = width - windowWidth + sliderLeftOffset;
        this.animating = true;

        if ( direction == 'prev' ) {
            //$('.slider-arrow.prev').addClass('hidden');
            //$('.slider-arrow.next').removeClass('hidden');
            //$('>ul', this.element).stop();
            actualMargin = parseInt($('>ul', this.element).css('margin-left'));
            actualMove = actualMargin + motiveOuterWidth;

            $('>ul', this.element).animate({'margin-left' : actualMove}, self.options.slideDuration, function() {
                $(parentEl).removeClass('hideSliderRightShadow');
                if ( actualMove >= 0 ) {
                    //$('.slider-arrow.next', el).addClass('hidden');
                    $(parentEl).removeClass('showSliderShadows');
                }
                self.animating = false;
                //$('>ul:first>li:last', self.element).prependTo($('>ul', el));
                //$('>ul', self.element).css({'margin-left' : - self.options.motiveOuterWidth + 'px'});
            });
        } else {
            //$('.slider-arrow.next').addClass('hidden');
            //$('.slider-arrow.prev').removeClass('hidden');
            //$('>ul', this.element).stop();
            $(this.parentElement).addClass('showSliderShadows');
            actualMargin = parseInt($('>ul', this.element).css('margin-left'));
            actualMove = actualMargin - motiveOuterWidth;
            $('>ul', this.element).animate({'margin-left' : actualMove + 'px'}, self.options.slideDuration, function() {
                if ( Math.abs(actualMove) >= sliderEndPosition ) {
                    //$('.slider-arrow.next', el).addClass('hidden');
                    $(parentEl).addClass('hideSliderRightShadow');
                }
                self.animating = false;
            //$('>ul', this.element).animate({'margin-left' : - sliderEndPosition + 'px'}, self.options.slideDuration, function() {
                //$('>ul:first>li:eq(0)', self.element).appendTo($('>ul', el));
                //$('>ul', self.element).css({'margin-left' : - self.options.motiveOuterWidth + 'px'});
            });
        }
    }
    this.actualSlide = to;
    //this.startRotation();
};


BetonSlider.prototype.listenForLoad = function() {
    var self = this;

    $(window).on('load', function() {
        $('img:lt(5)', self.element).unveil();
    });
};

BetonSlider.prototype.listenForResize = function() {
  var self = this;

  $(window).on('resize', function() {
    var imgWidth = $('img', self.element).width();
    $(self.parentElement).removeClass('showSliderShadows').removeClass('hideSliderRightShadow');
    $(self.element).empty();
    self.initialise();
  });
};

/**
 * start
 */
BetonSlider.prototype.startRotation = function() {
    var self = this;
    clearTimeout(this._changeTimer);
    this._changeTimer = setTimeout(function() {
        self.rotate(self.actualSlide, 'next');
    }, self.options.slideTime);
};

/**
 * decide, which methods will be "public"
 */
var API = {
    //action: BetonSlider.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
    var args = arguments;

    return this.each(function() {
        var $this = $(this);

        // get plugin instance
        var plugin = $this.data('plugin_' + PLUGIN_NAME);

        // if there's not, create one
        if (!plugin) {
            plugin = new BetonSlider(this, value);
            $this.data('plugin_' + PLUGIN_NAME, plugin);
        }
        // if there is and first parameter is in predefined API methods, call it with rest of params
        else if (API[value]) {
            plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
        }
    });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.beton-slider.js